import { render, staticRenderFns } from "./LegalFooter.vue?vue&type=template&id=5e3879d4"
import script from "./LegalFooter.vue?vue&type=script&lang=ts"
export * from "./LegalFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports